import { QueryErrorResetBoundary, type QueryKey } from '@tanstack/react-query';
import React, { cloneElement, ReactElement, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { RetryQueryAlert } from 'src/components/alerts/RetryQueryAlert';

type ErrorBoundarySuspenseProps = {
  loadingFallback: ReactElement;
  errorFallbackWrapper: ReactElement;
  queryKey: QueryKey;
  children: ReactElement;
  message?: string;
};

export function ErrorBoundarySuspense({
  loadingFallback,
  errorFallbackWrapper,
  queryKey,
  children,
  message,
}: ErrorBoundarySuspenseProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => {
            return cloneElement(
              errorFallbackWrapper,
              {},
              <RetryQueryAlert
                queryKey={queryKey}
                message={message}
                isLoading={false}
                onRetry={resetErrorBoundary}
              />,
            );
          }}
        >
          <Suspense fallback={loadingFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
